import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppraisalAttachment } from "../../all_Interfaces";


interface InitialState {
    data: AppraisalAttachment[],
    error: string,
    loading: boolean
}
const initialState: InitialState =
{
    data: [] as AppraisalAttachment[],
    error: '',
    loading: false
}

const updateAttachmentsSlice = createSlice({
    name: "UpdateAttachments",
    initialState,
    reducers: {
        updateAttachments(state, action: PayloadAction<AppraisalAttachment[]>) {
            state.data = action.payload;
        },
    },
});

export const { updateAttachments } = updateAttachmentsSlice.actions;

export default updateAttachmentsSlice.reducer;